import * as React from 'react';
const reactRouter = require('react-router');
const Router = reactRouter.Router;

// Routes
import configureRoutes from './configureRoutes';

// https://github.com/gaearon/react-hot-boilerplate/pull/61#issuecomment-218333616
// https://github.com/rybon/counter-hmr/blob/e651ce25b3a307f13ca53c977f9e8709ba873407/src/components/Root.jsx
const Root = ({history}) => {
  if (!Router) {
    console.error('Router is undefined! react-router module:', reactRouter);
    const exports = reactRouter ? Object.keys(reactRouter).join(', ') : 'react-router is null/undefined';
    return <div style={{padding: '20px', color: 'red'}}>
      <h2>Application Error</h2>
      <p>Router component not found. Check browser console for details.</p>
      <pre>react-router exports: {exports}</pre>
    </div>;
  }
  
  if (!history) {
    console.error('History is undefined!');
    return <div style={{padding: '20px', color: 'red'}}>Error: History is not provided</div>;
  }
  
  const routes = configureRoutes();
  if (!routes) {
    console.error('Routes are undefined!');
    return <div style={{padding: '20px', color: 'red'}}>Error: Routes are not configured</div>;
  }
  
  try {
    return (
      <Router history={history}>
        {routes}
      </Router>
    );
  } catch (error) {
    console.error('Error rendering Router:', error);
    return <div style={{padding: '20px', color: 'red'}}>
      <h2>Application Error</h2>
      <p>Error rendering Router. Check browser console for details.</p>
      <pre>{error.toString()}</pre>
    </div>;
  }
};

export default Root;
